import { useQuery } from '@tanstack/react-query';
import { getScheduledCustomSurveys } from '../../api/customSurveys';

export enum GetScheduledCustomSurveysCacheKey {
  ScheduledCustomSurveys = 'SCHEDULED_CUSTOM_SURVEYS',
}

export const useGetScheduledCustomSurveysQuery = (teamId: number) => {
  return useQuery({
    queryKey: [GetScheduledCustomSurveysCacheKey.ScheduledCustomSurveys, teamId],
    queryFn: () => getScheduledCustomSurveys(teamId),
    enabled: Boolean(teamId),
  });
};
